import * as React from "react";
import { ResponsiveContainer, Tooltip, CartesianGrid, XAxis, YAxis, AreaChart, Area, Legend } from "recharts";
import { CustomTooltipGAWeekComparison } from "src/share/components/CustomTooltip/CustomTooltip";
import { Col } from "reactstrap";
import { GoogleAnalyticsService } from "src/share/services/ga";

export interface IGAWeeksComparisonProps {
  pagePath?: string;
  views: {
    query: {
      ids: string
    }
  }
}
export interface IGAWeeksComparisonState {
  data: any[]
}
export class GAWeeksComparison extends React.PureComponent<IGAWeeksComparisonProps, IGAWeeksComparisonState> {
  public chartNode;
  public chart;

  constructor(props) {
    super(props);
    this.state = {
      data: []
    }
  }
  public componentDidMount() {
    this.getData();
  }
  public componentDidUpdate(prevProps: IGAWeeksComparisonProps) {
    if (this.props.views.query.ids !== prevProps.views.query.ids || this.props.pagePath !== prevProps.pagePath) {
      this.getData()
    }
  }
  public async getData() {
    const data = await GoogleAnalyticsService.getSessionsByWeek(this.props.views.query.ids, this.props.pagePath);
    this.setState({ data })
  }
  public render() {
    return (
      <Col className="col-12 white-background">
        <h5>This Week vs Last Week </h5>
        <h6 className="subtitle">Sessions</h6>
        <ResponsiveContainer width={'95%'} height={310}>
          <AreaChart height={310} data={this.state.data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip content={<CustomTooltipGAWeekComparison />} />
            {this.state.data.length > 0 && <Area type='monotone' dataKey='last' stroke='#D16200' fill='#D16200' />}
            {this.state.data.length > 0 && <Area type='monotone' dataKey='current' stroke='#2ABCCA' fill='#2ABCCA' />}
            {this.state.data.length === 0 && <Area type='monotone' dataKey='No data to show' stroke='grey' fill='grey' />}
            <Legend align="center" verticalAlign="top" layout='horizontal' />
          </AreaChart>
        </ResponsiveContainer>
      </Col>
    );
  }
}


// WEBPACK FOOTER //
// ./src/share/components/GoogleAnalitycs/GAWeeksComparison.tsx